import React, { useContext } from "react";
import { useHistory } from "react-router-dom";

import DatabaseContext from "data/contextDatabase";

const UIPersona = (props) => {
  const { databaseState, databaseDispatch } = useContext(DatabaseContext);

  let history = useHistory();

  const sortJoin = (A, B, Delim) => {
    return A < B ? A + Delim + B : B + Delim + A;
  };

  const createDialog = () => {
    console.log(
      "addDialog = ",
      props.muid, // your muid
      props.mpersona, // your mpersona
      props.persona, // your persona
      props.rpersona.npersona,
      props.rpersona.persona
    );
    let d = {
      dialog: props.rpersona.persona,
      got_voice: true,
      mdialog: sortJoin(props.mpersona, props.rpersona.mpersona, "_"),
      mpersona: props.mpersona,
      persona: props.persona,
      peer: props.rpersona.mpersona,
      peerpersona: props.rpersona.persona,
      visibility: "PRIVATE_DIALOG",
    };
    databaseDispatch({
      type: "UPSERT_REC",
      values: {
        db: databaseState.dbMaster,
        collection: "dialog",
        table: props.muid,
        rowid: sortJoin(props.mpersona, props.rpersona.mpersona, "_"),
        doc: d,
      },
    });
    history.push("/UIMessageList", {
      dialog: d,
    });
  };

  let content = (
    <div className="UI-topic" onClick={() => createDialog()}>
      <div style={{ color: "#333333" }}>{props.rpersona.persona}</div>
      <div style={{ color: "#333333" }}>{props.rpersona.last_seen}</div>
    </div>
  );

  return content;
};

export default React.memo(UIPersona, (prevProps, nextProps) => {
  return prevProps === nextProps;
});
